/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Header MM MENU JS
  const menuRoot = document.querySelector(".drawer .drawer__inner .sliderow.static-mm-menu.resources");

  if (menuRoot) {
    menuRoot.querySelectorAll(".mega-menu__linklist .menu__heading").forEach(function (heading) {
      heading.addEventListener("click", function () {
        const parent = this.closest(".mega-menu__linklist");

        menuRoot.querySelectorAll(".mega-menu__linklist.is-active").forEach(function (item) {
          if (item !== parent) {
            item.classList.remove("is-active");
          }
        });
        parent.classList.toggle("is-active");
      });
    });
  }

  // product thumblie slider

    const desktopMedia = window.matchMedia('(min-width: 1024px)');
    if (!desktopMedia.matches) return;

    const holderSelector = '.product__thumbs__holder';
    const slideSelector = '.product__thumb';

    let isDown = false;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let activeHolder = null;

    document.addEventListener(
      'mousedown',
      function (e) {
        const holder = e.target.closest(holderSelector);
        const slide = e.target.closest(slideSelector);
        if (!holder || !slide) return;

        isDown = true;
        isDragging = false;
        activeHolder = holder;

        startX = e.pageX;
        scrollLeft = holder.scrollLeft;
        holder.style.scrollBehavior = 'auto';
      },
      true
    );

    document.addEventListener(
      'mousemove',
      function (e) {
        if (!isDown || !activeHolder) return;

        const walk = e.pageX - startX;
        if (Math.abs(walk) > 5) {
          isDragging = true;
          activeHolder.classList.add('is-dragging');
          activeHolder.scrollLeft = scrollLeft - walk;
          e.preventDefault();
        }
      },
      true
    );

    document.addEventListener(
      'mouseup',
      function () {
        if (!isDown) return;
        activeHolder && activeHolder.classList.remove('is-dragging');
        isDown = false;
        activeHolder = null;
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        if (!isDragging) return;
        const holder = e.target.closest(holderSelector);
        if (holder) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    document.addEventListener(
      'wheel',
      function (e) {
        const holder = e.target.closest(holderSelector);
        if (!holder) return;

        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          holder.scrollLeft += e.deltaY;
        }
      },
      { passive: false }
    );
    
  // Add custom code below this line
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll(".template-product .accordion .meta-info.faq-item .info-title");
  titles.forEach(function (title) {
    title.addEventListener("click", function () {
      const parent = this.closest(".meta-info.faq-item .meta-block");
      if (parent) {
        parent.classList.toggle("is-active");
      }
    });
  });
});


const initPopoutHandlers = () => {
  const toggles = document.querySelectorAll('.product-form__input button.select-popout__toggle');

  toggles.forEach((btn) => {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const container = this.closest('.select-popout') || this.parentElement;
      const popoutList = container.querySelector('.select-popout__list');

      if (popoutList) {
        const isOpening = !popoutList.classList.contains('popout-list--visible');

        if (isOpening) {
          popoutList.classList.add('popout-list--visible');
          this.setAttribute('aria-expanded', 'true');

          const rect = popoutList.getBoundingClientRect();
          const viewportHeight = rect.bottom > window.innerHeight;

          if (viewportHeight == true) {
            popoutList.classList.add('popout-list--top');
          } else {
            setTimeout(() => popoutList.classList.remove('popout-list--top'), 100);
          }
        } else {
          popoutList.classList.remove('popout-list--visible');
          setTimeout(() => popoutList.classList.remove('popout-list--top'), 100);
          this.setAttribute('aria-expanded', 'false');
        }
      }
    },true);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPopoutHandlers);
} else {
  initPopoutHandlers();
}

class ProductPopup {
  constructor(buttonSelector, popupAttr) {
    this.buttons = document.querySelectorAll(`[${buttonSelector}]`);
    this.popupAttr = popupAttr;
    this.init();
  }

  init() {
    this.buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const popupId = btn.getAttribute(this.popupAttr);
        const popupElement = document.getElementById(popupId);
        
        if (popupElement) {
          this.open(popupElement);
        }
      });
    });
  }

  open(modal) {
    modal.style.display = 'block';
    requestAnimationFrame(() => {
      modal.style.opacity = '1';
    });
    
    document.body.style.overflow = 'hidden';
    modal.setAttribute('aria-hidden', 'false');
    const handleClose = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.close(modal);
    };

    modal.querySelectorAll('.product-modal__close, [data-modal-close], .product-modal__overlay').forEach(btn => {
      btn.removeEventListener('click', handleClose);
      btn.addEventListener('click', handleClose, { once: true });
    });
    
    modal.onclick = (e) => {
      if (e.target === modal) {
        this.close(modal);
      }
    };
  }

  close(modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      modal.setAttribute('aria-hidden', 'true');
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductPopup('data-product-popup', 'data-product-popup');
});

document.addEventListener('DOMContentLoaded', function () {
  let slides = document.querySelectorAll('.unique-review-slide');
  let dots = document.querySelectorAll('.unique-review-dot');
  let currentSlide = 0;
  let reviewSection = document.querySelector('.unique-review-section');
  if (!reviewSection) return;
  let autoplaySpeed = reviewSection.getAttribute('data-autoplay-speed');

  function showSlide(index) {
    slides.forEach(slide => slide.style.display = 'none');
    dots.forEach(dot => dot.classList.remove('active'));
    slides[index].style.display = 'block';
    dots[index].classList.add('active');
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentSlide = index;
      showSlide(currentSlide);
    });
  });

  showSlide(currentSlide);
  setInterval(nextSlide, autoplaySpeed);
});


document.addEventListener("DOMContentLoaded", function(){
  const reviewForm = document.getElementById('review-add-to-cart-form');
  if(reviewForm) {
    reviewForm.addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this);

      const addToCartButton = document.getElementById('review-add-to-cart-button');

      addToCartButton.textContent = 'Adding...';
      addToCartButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json', 
        },
      })
      .then(response => response.json())
      .then(data => {
        addToCartButton.textContent = 'Thank you!';

        $('body').trigger('added.ajaxProduct');

        setTimeout(() => {
          addToCartButton.textContent = 'Get Your Free Sample Pack Now';
          addToCartButton.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        addToCartButton.textContent = 'Error, please try again';
        setTimeout(() => {
          addToCartButton.textContent = 'Get Your Free Sample Pack Now';
          addToCartButton.disabled = false;
        }, 2000);
      });
    });
  }

  const superfoodForm = document.getElementById('superfood-add-to-cart-form');
  if(superfoodForm) {
    superfoodForm.addEventListener('submit', function(event) {
      event.preventDefault();
      const formData = new FormData(this);
      const addToCartButton = document.getElementById('superfood-add-to-cart-button');
      addToCartButton.textContent = 'Adding...';
      addToCartButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json', 
        },
      })
      .then(response => response.json())
      .then(data => {
        addToCartButton.textContent = 'Thank you!';
        $('body').trigger('added.ajaxProduct');

        setTimeout(() => {
          addToCartButton.textContent = 'Get Your Free Sample Pack Now';
          addToCartButton.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        addToCartButton.textContent = 'Error, please try again';
        setTimeout(() => {
          addToCartButton.textContent = 'Get Your Free Sample Pack Now';
          addToCartButton.disabled = false;
        }, 2000);
      });
    });
  }
});

(function(){
  function initFaqSection(){
    const section = document.querySelector('.tab-custom-accordion-container');
    if(!section) return;

    const tabContents = section.querySelectorAll(".tab_content");
    const tabs = section.querySelectorAll("ul.tabs li");
    const drawerHeadings = section.querySelectorAll(".tab_drawer_heading");
    const accordionHeaders = section.querySelectorAll('.custom-accordion-header');

    tabContents.forEach(el => el.style.display = "none");
    if(tabContents.length){
      tabContents[0].style.display = "block";
    }

    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        tabContents.forEach(el => el.style.display = "none");
        const activeTab = this.getAttribute("rel");
        const target = section.querySelector("#" + activeTab);
        if (target) target.style.display = "block";
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");
      });
    });

    drawerHeadings.forEach(drawer => {
      drawer.addEventListener("click", function () {
        tabContents.forEach(el => el.style.display = "none");
        const activeTab = this.getAttribute("rel");
        const target = section.querySelector("#" + activeTab);
        if (target) target.style.display = "block";
        drawerHeadings.forEach(d => d.classList.remove("d_active"));
        this.classList.add("d_active");
      });
    });

    accordionHeaders.forEach(header => {
      header.addEventListener('click', () => {
        const item = header.parentElement;
        item.classList.toggle('open');
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initFaqSection);
  document.addEventListener("shopify:section:load", initFaqSection);
  document.addEventListener("DOMContentLoaded", function(){
    const form = document.getElementById('faq-add-to-cart-form');
    if(!form) return;

    form.addEventListener('submit', function(event){
      event.preventDefault();
      const button = document.getElementById('faq-add-to-cart-button');
      if(!button) return;

      const formData = new FormData(form);
      button.textContent = 'Adding...';
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(res => res.json())
      .then(() => {
        if(window.jQuery){
          jQuery('body').trigger('added.ajaxProduct');
        }
        button.textContent = 'Thank you!';
        setTimeout(() => {
          button.textContent = 'Get Your Free Sample Pack Now';
          button.disabled = false;
        }, 2000);
      })
      .catch(() => {
        button.textContent = 'Error, try again';
        setTimeout(() => {
          button.textContent = 'Get Your Free Sample Pack Now';
          button.disabled = false;
        }, 2000);
      });
    });
  });
})();

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll(".template-product .standard__ctas").forEach(function (element) {
    element.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  });

  const mq = window.matchMedia('(min-width: 750px) and (max-width: 989px)');
  function toggleGridSlider(e) {
    const el = document.querySelector('.template-product .tab-content .recent__content.grid--mobile-slider');
    if (!el) return;

    if (e.matches) {
      el.classList.add('grid--slider');
    } else {
      el.classList.remove('grid--slider');
    }
  }
  toggleGridSlider(mq);
  mq.addEventListener('change', toggleGridSlider);
});

function closeCartDrawer() {
  const btn = document.querySelector('#cart-drawer .drawer__close, #cart-drawer [data-cart-drawer-close]');
  if (btn) btn.click();
}

function attachListener() {
  document.addEventListener('rebuy:smartcart.hide', closeCartDrawer);
  window.addEventListener('rebuy:smartcart.hide', closeCartDrawer);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachListener);
} else {
  attachListener();
}